import { KeyTermType } from '@client/graphql/__generated__/types';
import { ReactNode } from 'react';
import {
  CommonKeyTermProps,
  useCommonKeyTermLogic,
} from './useCommonKeyTermLogic';
import { usePurchasePriceLogic } from './usePurchasePriceLogic';
import {
  SellerConcessionProps,
  useSellerConcessionLogic,
} from './useSellerConcessionLogic';

export type BaseKeyTermLogicProps<T extends KeyTermType> = {
  row: T;
} & SellerConcessionProps &
  CommonKeyTermProps;

type IReturn = {
  isSingleRangeValue: boolean;

  getPlaceholderValue: () => string | number | undefined;
  getDotColorValue: (value?: number | null) => string;
  getRangeLabel: () => string | number | undefined;

  // Optional for specific key terms overrides
  getMainValueLabel?: () => ReactNode;
  getRangeTrackTooltipContent?: (props: {
    children: ReactNode;
    isOpen: boolean;
  }) => ReactNode;
  getAnchor?: () => { value: number; label: string } | undefined;
  getHighlightedRange?: () => [number, number] | undefined;
};

export const useKeyTermOverrideLogic = <T extends KeyTermType>(
  props: BaseKeyTermLogicProps<T>
): IReturn => {
  const commonLogic = useCommonKeyTermLogic(props);

  const overrideLogic: Record<KeyTermType, Partial<IReturn>> = {
    [KeyTermType.PURCHASE_PRICE]: usePurchasePriceLogic(props),
    [KeyTermType.SELLER_CONCESSIONS]: useSellerConcessionLogic(props),
    [KeyTermType.DUE_DILIGENCE]: {},
    [KeyTermType.DUE_DILIGENCE_DAYS]: {},
    [KeyTermType.EARNEST_MONEY]: {},
    [KeyTermType.OFFER_TO_CLOSE_DAYS]: {},
    [KeyTermType.TERMINATION_FEE]: {},
  };

  return {
    ...commonLogic,
    ...overrideLogic[props.row],
  };
};
